import React, {useState} from 'react';
import ReactDOM from 'react-dom';

import { useRouteNode } from 'react-router5';

import {useDispatch, useSelector} from "react-redux";
import {getTrending} from "../redux/tendances/tendanceSlice";

import './style/postfeed.css'
import {PostList} from './postList';
import { getPostsDaysAgo } from "../api";

import CartoGeoPost from '../carto/carto_geo_post';

import { FilterDays, FilterGeo, FilterSearchMode, FilterContainer } from '../components/filter/filter';

const PostFeed = ({ portal_ref }) => {
  const { route: {data} } = useRouteNode('postfeed')
  const [posts, setPosts] = useState([]);
  const [filtered_posts, setFilteredPosts] = useState([]);
  const [bookmarks] = useState(data.bookmarks);

  const [init, setInit] =  useState(false);
  const duration = useSelector((state) => state.tendance.value);
  const dispatch = useDispatch();

  const [feed_mode, setFeedMode] =  useState("all");
  const [center, setCenter] =  useState(null);
  const [geo_filter, setGeoFilter] =  useState(null);

  function getFeed(feed_mode, days_ago) {
    getPostsDaysAgo(feed_mode, days_ago).then(({data}) => {
      const sorted_data = data.sort((a, b) => {
        const date_a = a.publish_date || a.inserted_at;
        const date_b = b.publish_date || b.inserted_at;

        return - date_a.localeCompare(date_b);
      })

      setPosts(sorted_data);
      setFilteredPosts(sorted_data);
    })
  }

  if (!init) {
    setInit(true);
    getFeed(feed_mode, duration)
  }

  function setDuration(number){
    dispatch(getTrending(number));
    getFeed(feed_mode, number)
  }


  function onChangeFeedMode(new_feed_mode) {
    if (feed_mode !== new_feed_mode) {
      setFeedMode(new_feed_mode);
      getFeed(new_feed_mode, duration)
    }
  }

  function onGeoTextClick(post) {
    setCenter(post)
  }

  function onGeoPointClick(geo) {
    const {id: ref_id} = geo;

    setGeoFilter(geo);

    // take points which belong to the clicked geo point
    setFilteredPosts(
      posts.filter(({geo}) => {
        return geo.id === ref_id || geo.subroot === ref_id || geo.root === ref_id
      })
    )
  }

  function unfilterGeo() {
    setGeoFilter(null);
    setFilteredPosts(posts);
  }

  return <>
    { portal_ref.current && ReactDOM.createPortal(
      <FilterContainer>
        <FilterDays set={setDuration} value={duration} />
        <FilterGeo set={unfilterGeo} geo={geo_filter} />
      </FilterContainer>,
      portal_ref.current)
    }

    <div className={'postfeedContainer'}>
      <div className={'left'}>
        <CartoGeoPost posts={posts} center={center} onClick={onGeoPointClick}
         map_settings={data.map_settings_post_geo} geo_filter={geo_filter} />
      </div>
      <div className={'right'}>
        <div className={'postFeedTitleContainer'}>
            <FilterSearchMode mode={feed_mode} set={onChangeFeedMode} />
        </div>
        <div className={'postFeed'}>
          <PostList users={data.users}
            onGeoClick={onGeoTextClick}
            bookmarks={bookmarks} apiCall={() => {}}
            posts={filtered_posts} cursor={false} />
        </div>
      </div>
    </div>
  </>
}

export default PostFeed;
